import { MatDateFormats } from "@angular/material/core";

export const DATE_FORMATS: MatDateFormats = {
    parse: {
        dateInput: 'yyyy/MM/dd',
    },
    display: {
        dateInput: 'yyyy/MM/dd',
        monthYearLabel: 'MMM yyyy',
        dateA11yLabel: 'yyyy/MM/dd',
        monthYearA11yLabel: 'MMMM yyyy',
    }
};
